import React from 'react'
import PropTypes from 'prop-types'

const ArrowUp = (props) => {
    return (
        <svg
            id="Layer_1"
            version="1.1"
            viewBox="0 0 92 92"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            xmlSpace="preserve">
            <path
                id="XMLID_453_"
                d="M71,63c-1.1,0-2.1-0.4-2.9-1.2L46,38.8l-22.1,23c-1.5,1.6-4.1,1.6-5.7,0.1c-1.6-1.5-1.6-4.1-0.1-5.7l25-26&#xA;&#x9;c0.8-0.8,1.8-1.2,2.9-1.2s2.1,0.4,2.9,1.2l25,26c1.5,1.6,1.5,4.1-0.1,5.7C73,62.6,72,63,71,63z"
            />
        </svg>
    )
}

export default ArrowUp
